<template>
  <div
    class="sourceMobile"
    :style="{
      '--source-color-dark': `var(--${color}-dark)`,
      '--source-color-main': `var(--${color}-main)`,
    }"
  >
    <HeaderSource
      v-if="lastUpdated"
      :title="titleName"
      :year="lastUpdated"
      class="sourceMobile__header"
    />
    <FiltersMobile class="sourceMobile__filters"></FiltersMobile>
    <div v-if="!isNoData" class="sourceMobile__content">
      <TimeSerie class="sourceMobile__content__time-serie"></TimeSerie>
      <div class="sourceMobile__content__dynamic">
        <component
          v-if="sourceConfig"
          :is="sourceConfig.detailComponent"
        ></component>
      </div>
    </div>
    <div class="sourceMobile__center">
      <MapWrapperMobile fixedText="Top 10 Countries for "></MapWrapperMobile>
    </div>
    <!-- <div
      v-if="isNoData"
      class="sourceMobile__noData"
      :style="{
        backgroundImage: `url(${$baseUrl}images/griglia.png)`,
      }"
    >
      NO DATA
    </div> -->
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import HeaderSource from "./sourceComponents/HeaderSource.vue";
import FiltersMobile from "./sourceComponents/FiltersMobile.vue";
import TimeSerie from "@/components/widgets/TimeSerie.vue";
import TotalShare from "@/components/widgets/TotalShare.vue";
import SelectionLabel from "../widgets/SelectionLabel.vue";
import Growth from "@/components/widgets/Growth.vue";
import Map from "@/components/widgets/Map.vue";
import MapWrapperMobile from "./sourceComponents/MapWrapperMobile.vue";

export default {
  name: "SourcePageMobile",
  components: {
    HeaderSource,
    FiltersMobile,
    TimeSerie,
    TotalShare,
    Growth,
    Map,
    SelectionLabel,
    MapWrapperMobile,
  },
  mounted() {
    // get key from url
    this.setMainSource(this.$route.params.source);
  },
  computed: {
    titleName() {
      return this.$route.params.source.toUpperCase();
    },
    showGrowthComponent() {
      return this.setMainSource === "Critical Minerals";
    },
    color() {
      return this._color();
    },
    ...mapGetters({
      sourceConfig: "ui/currentSourceConfig",
      _color: "ui/sourceColor",
      isNoData: "data/isNoData",
      lastUpdated: "data/getLastUpdated",
    }),
  },
  methods: {
    ...mapActions({
      setMainSource: "ui/setMainSource",
    }),
  },
};
</script>

<style lang="scss" scoped>
$widget-left-width: 24%;
$widget-right-width: 250;
.sourceMobile {
  height: 100vh;
  width: 100vw;
  overflow-y: scroll;
  background-color: var(--source-color-dark);

  &__filters {
    margin-top: 9.21vh;
  }
  &__content {
    background-color: var(--source-color-dark);
    transition: all 0.4s ease;
    width: 100vw;
  }

  &__noData {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 10;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    @include title-H3;
    color: $ui-white;
    background-position: center;
    background-size: cover;
    background-color: var(--source-color-dark);
  }
}

.tablet {
  .sourceMobile {
    &__filters {
      margin-top: 5.72vh;
    }
    &__content {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      grid-template-rows: 1fr;
      border-bottom: $white-border;
      height: 28vh;

      &__time-serie {
        grid-area: 1 / 1 / 2 / 2;
      }

      &__dynamic {
        height: 100%;
        grid-area: 1 / 2 / 2 / 3;
      }
    }
  }
}
</style>
